import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createBlock(_component_v_row, { class: "mt-2 mb-2" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_col, {
        cols: "4",
        class: "pr-2"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_btn, {
            class: "",
            variant: "outlined",
            width: "100%",
            onClick: _ctx.saveDraft,
            loading: _ctx.btnDraftLoading,
            disabled: _ctx.disabled
          }, {
            default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
              _createElementVNode("div", null, [
                _createElementVNode("div", { class: "captionText" }, "下書きへ"),
                _createElementVNode("div", { class: "text-button font-weight-bold message-btn" }, "保存")
              ], -1)
            ]))]),
            _: 1
          }, 8, ["onClick", "loading", "disabled"])
        ]),
        _: 1
      }),
      _createVNode(_component_v_col, {
        cols: "4",
        class: "pl-1 pr-1"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_btn, {
            class: "",
            color: "primary",
            variant: "outlined",
            width: "100%",
            onClick: _ctx.saveSendReady,
            loading: _ctx.btnReadyLoading,
            disabled: _ctx.disabled
          }, {
            default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
              _createElementVNode("div", null, [
                _createElementVNode("div", { class: "captionText" }, "送信準備BOXへ"),
                _createElementVNode("div", { class: "text-button font-weight-bold message-btn" }, "保存")
              ], -1)
            ]))]),
            _: 1
          }, 8, ["onClick", "loading", "disabled"])
        ]),
        _: 1
      }),
      _createVNode(_component_v_col, {
        cols: "4",
        class: "pl-2"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_btn, {
            class: "",
            color: "primary",
            variant: "flat",
            width: "100%",
            onClick: _ctx.sendMessage,
            loading: _ctx.btnSendLoading,
            disabled: _ctx.disabled
          }, {
            default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
              _createElementVNode("div", null, [
                _createElementVNode("div", { class: "captionText" }, "いますぐ"),
                _createElementVNode("div", { class: "text-button font-weight-bold message-btn" }, "送信")
              ], -1)
            ]))]),
            _: 1
          }, 8, ["onClick", "loading", "disabled"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}